import axios from "axios";
import { API } from "./api";

const USER_TOKEN_KEY = "sugandhi_user_token";
const USER_KEY = "sugandhi_user";

export const getUserToken = () => localStorage.getItem(USER_TOKEN_KEY);
export const setUserToken = (t) => localStorage.setItem(USER_TOKEN_KEY, t);
export const clearUserToken = () => { localStorage.removeItem(USER_TOKEN_KEY); localStorage.removeItem(USER_KEY); };
export const getStoredUser = () => {
  try { return JSON.parse(localStorage.getItem(USER_KEY) || "null"); } catch { return null; }
};
export const setStoredUser = (u) => localStorage.setItem(USER_KEY, JSON.stringify(u));

export const userApi = axios.create({ baseURL: API });
userApi.interceptors.request.use((cfg) => {
  const t = getUserToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const sendOtp = (phone) => userApi.post("/auth/whatsapp/send-otp", { phone }).then((r) => r.data);
export const verifyOtp = (phone, otp, name) => userApi.post("/auth/whatsapp/verify-otp", { phone, otp, name }).then((r) => r.data);

export const getMsg91Config = () => userApi.get("/config/msg91").then((r) => r.data);
export const msg91VerifyAccessToken = (access_token, phone, name) =>
  userApi.post("/auth/msg91/verify", { access_token, phone, name }).then((r) => r.data);

export const listReviews = (params = {}) => userApi.get("/reviews", { params }).then((r) => r.data);
export const postReview = (data) => userApi.post("/reviews", data).then((r) => r.data);
